import Swiper, {Navigation, Pagination, Lazy} from "swiper";
import resize from "../../utils/resize";
Swiper.use([Navigation, Pagination, Lazy]);

const initTeamSlider = () => {
  const sliderContainer = document.querySelector("[data-team-slider]");
  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(sliderContainer, {
        lazy: true,
        spaceBetween: 8,

        breakpoints: {
          500: {
            slidesPerView: 2,
          },
          0: {
            slidesPerView: 1,
          },
        },
        pagination: {
          el: "[data-team-slider-container] .swiper-pagination",
          clickable: true,
          bulletElement: "button",
        },
        navigation: {
          nextEl: "[data-team-slider-container] .slider-navigation__button--next",
          prevEl: "[data-team-slider-container] .slider-navigation__button--prev",
        },
      });
    }
  }

  function destroy() {
    if (swiper) {      
      swiper.destroy();
      swiper = null;
    }
  }

  function resizeSwiper () {
    window.innerWidth <= 767
      ? init()
      : destroy();
  }
  
  sliderContainer && resizeSwiper();
  sliderContainer && resize(resizeSwiper);
};

export default initTeamSlider;
